import axios from "axios";

const bagnoArrivalModule = {
  namespaced: true,
  state: {
    items: [],
    selected: [],
    containers: [
      {text: 'Cargando...', value: null},
    ],
  },
  getters: {
    totalNet: state => {
      return state.items.reduce((acc, item) => acc + item.net_weight, 0);
    },
    totalQuantity: state => {
      return state.items.reduce((acc, item) => acc + item.quantity, 0);
    },
    checkCompletedPallet(state, getters) {
      return getters.completedPallet / state.items.length === 1;
    },
    completedPallet: state => {
      return state.items.reduce((r, o) =>
        r + +!Object.values(o).includes(null)
        , 0)
    },
    itemsSelectedCount: state => {
      return state.selected.length;
    }
  },
  mutations: {
    addRows(state, payload) {
      let current_index = state.items.length;
      for (let i = 0; i < payload.pallet_quantity; i++) {
        let d = new Date().getTime()
        let n = (current_index + i + 1)
        state.items.push({
          idx: current_index + i + 1,
          number: d+ "R"+n,
          lot: payload.lot,
          code: payload.code,
          description: payload.description,
          product_id: payload.product_id,
          quantity: payload.quantity,
          gross_weight: null,
          net_weight: null,
          container:payload.container,
          material_weight:  payload.material_weight,
          selected: false,
          pallet_type: payload.pallet_type,
        });
      }
    },

    updateRow(state, payload) {
      const objIndex = state.items.findIndex((obj => obj.idx === payload.id));
      state.items[objIndex].quantity = payload.quantity;
      state.items[objIndex].container = payload.container;
      state.items[objIndex].gross_weight = payload.gross_weight;
      state.items[objIndex].net_weight = payload.netWeight;
    },

    selectRow(state, payload) {
      state.items[payload].selected = !state.items[payload].selected;
    },

    addRowsToSelected(state, payload) {
      state.selected = payload
    },

    removeAll(state) {
      state.items = [];
      state.selected = [];
      state.containers = [{text: 'Cargando...', value: null}];
    },

    removeRows(state, payload) {
       let deleteIndex = state.items.findIndex(
        (obj => obj.idx === payload.idx)
      );
      state.items.splice(deleteIndex, 1);
    },
    getContainers(state, payload) {
      state.containers = payload;
    },
    clearSelected(state) {
      state.selected = [];
    }
  },
  actions: {
    addRows: ({commit}, payload) => {
      commit('addRows', payload);
    },
    addRowsToSelected: ({commit}, payload) => {
      commit('addRowsToSelected', payload);
    },
    selectRow: ({commit}, payload) => {
      commit('selectRow', payload);
    },
    updateRow: ({commit}, payload) => {
      commit('updateRow', payload);
    },
    removeRows: ({commit}, payload) => {
      commit('removeRows', payload);
    },
    removeAll: ({commit}) => {
      commit('removeAll');
    },
    clearSelected: ({commit}) => {
      commit('clearSelected');
    },
    getContainers: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        let url = '/bagno/container/select_container/?finished_product=';
        url += payload === 'PALLETS';

        axios.get (url)
          .then(res => {
            const data = res.data;
            let containers = [];
            for (let key in data) {
              const container = data[key];
              containers.push(container)
            }
            payload = containers;
            commit('getContainers', payload);
            resolve(res)
          })
          .catch(error => {
            console.log(error);
            reject(error)
          })

      })


    },

  }
};

export default bagnoArrivalModule;
